import { connect } from 'react-redux'
import { closePasswordModal } from '../actions'
import { resetPassword } from '../actions/apiRequest'
import {
  resetForgetPwdForm, showCustomerForgotPasswordModal,
} from '../../Account/actions/index'
import ModalComponent from '../components/index'

import '../styles/index.scss'

const mapStateToProps = (state) => ({
  visible: state.password.showModal,
  apiActionFeedback: state.password.actionFeedback,
})

const mapDispatchToProps = (dispatch) => ({
  closeModal: () => {
    dispatch(closePasswordModal())
    dispatch(resetForgetPwdForm())
  },
  onSubmit: (params) => {
    dispatch(resetPassword(params))
  },
  showForgetPwdModal: () => {
    dispatch(showCustomerForgotPasswordModal())
  },
})

const Password = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ModalComponent)

export default Password
